import React, { useState } from "react";
import "./Online_Store.css";
import { Rating } from "react-simple-star-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Online_Store({ image, heading, city, distanceLocation, rating }) {
  // const [rating, setRating] = useState(0);

  const handleRating = (rate: number) => {
    // setRating(rate);
  };

  return (
    <>
      <div className="online-store text-center">
        <div className="pt-4">
          <div className="store-holder">
            <img src={image} className="store-img" />
          </div>
          <h2 className="mt-4">{heading}</h2>
          <div className="start-holder">
            <Rating
              initialValue={rating}
              fillColor="#DF4223"
              className="react-simple-star-rating start"
              SVGclassName="star-svg"
              readonly={true} // This makes the rating display-only
            />
          </div>
          <div className="location-holder my-1">
            <FontAwesomeIcon
              icon="fa-solid fa-location-dot"
              className="location-icon me-1"
            />
            <span>{city}</span>
          </div>
          {/* <p>{distanceLocation}</p> */}
        </div>
      </div>
    </>
  );
}

export default Online_Store;
